"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _usersDeprecated = require("../../users-deprecated");
var _actions = require("../actions");
var _actions2 = _interopRequireDefault(require("../../invitations-deprecated/actions"));
var _helpers = require("../../../helpers");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const mapStateToProps = function (state) {
  return {
    auth: state.auth,
    user: state.user
  };
};
let signUpSchema = (0, _helpers.objectToArray)(_usersDeprecated.schema);
signUpSchema = (0, _helpers.filterGuarded)(signUpSchema);
class SignUp extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      user: (0, _helpers.mapFieldsToState)(signUpSchema),
      messages: [],
      fetching: false
    });
    _defineProperty(this, "handleSubmit", event => {
      event.preventDefault();
      const {
        auth,
        history
      } = this.props;
      this.setState({
        fetching: true
      });
      return this.props.signUp(this.state.user).then(() => {
        this.setState({
          fetching: false,
          messages: [{
            type: "success",
            text: "You signed up successfully!"
          }]
        });
        return history.push(auth.onSignUpRedirect);
      }).catch(error => {
        this.setState({
          messages: [{
            type: "error",
            text: error.Message
          }],
          fetching: false
        });
        throw error;
      });
    });
    _defineProperty(this, "handleChange", body => {
      this.setState(state => {
        return {
          user: {
            ...state.user,
            ...body
          }
        };
      });
    });
    _defineProperty(this, "render", () => {
      const {
        children,
        ...rest
      } = this.props;
      return _react.default.cloneElement(children, {
        ...rest,
        state: this.state.user,
        messages: this.state.messages,
        fetching: this.state.fetching,
        onChange: this.handleChange,
        onSubmit: this.handleSubmit
      });
    });
  }
  componentDidMount() {
    this.props.getMyInvitation(this.props.id).catch(err => console.log(err));
  }
}
SignUp.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.array,
  getMyInvitation: _propTypes.default.func,
  id: _propTypes.default.string,
  signUp: _propTypes.default.func,
  onSignUpRedirect: _propTypes.default.func
} : {};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  signUp: _actions.signUp,
  getMyInvitation: _actions2.default.getMyInvitation
})(SignUp);
module.exports = exports.default;